import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetCashFlowQuery } from '../../data/queries/get-cash-flow.query'
import type { CashFlowResponse } from '../models/cash-flow'

export class GetCashFlowInteractor {
  constructor(private readonly getCashFlow: GetInteractor<CashFlowResponse>) {}

  public async execute(month: string, totalMonths: number, organization: string): Promise<CashFlowResponse> {
    return await this.getCashFlow.execute(new GetCashFlowQuery(month, totalMonths, organization))
  }
}
